
export const common = {
  // Navigation
  home: "首页",
  features: "功能特色",
  cases: "案例展示", 
  pricing: "价格方案",
  about: "关于我们",
  getStarted: "开始使用",
  language: "中文",

  // Common Actions
  contactUs: '联系我们',
  viewFaq: "查看常见问题",

  // Hero Section
  heroSubtitle: "Flidge，专注为独立游戏提供最优质的本地化服务",
  heroTitle1: "让世界各地不同地区的玩家",
  heroTitle2: "真正理解你的游戏",
  heroDescription: "借助先进的AI技术，为开发者提供准确、快速、经济实惠的多语言翻译解决方案，帮助您充分挖掘全球玩家市场和机遇",
  learnMore: "了解更多",
  freeTrial: "免费试用",
  socialProof: "80+游戏开发者和发行商的共同选择",
  
  // Features Section
  featuresSubtitle: "核心优势",
  featuresTitle: "高效的游戏本地化解决方案",
  
  feature1Title: "快速高效完成",
  feature1Description: "在更短的时间周期内完成准确、高质量的翻译工作，能够在1天内翻译20万字。显著提升游戏项目的本地化效率。相比传统人工翻译，显著减少人为错误，准确识别大小写和标点符号差异，翻译质量已获得翻译机构认证。",
  
  feature2Title: "多语言多场景支持", 
  feature2Description: "提供全球82种语言的翻译服务，支持游戏脚本、商店页面、游戏名称、术语表、官网等多场景内容翻译。全面满足您的本地化需求。",
  
  // Feature 2 Additional
  glossary: "术语表",
  gameTermsReference: "游戏术语参考",
  storePage: "商店页面",
  storePageDesc: "游戏名称、描述、卖点、标语",
  gameStoryTranslation: "游戏剧情翻译",
  gameStoryDesc: "主线任务故事、支线剧情",
  completed: "已完成",
  inProgress: "进行中",
  pending: "待处理",

  feature3Title: "支持多种文本格式",
  feature3Description: "支持多种文本格式的导入和导出，让您能够更好地将翻译后的文本加载到游戏项目中使用。无论您使用什么游戏引擎，都能高效集成。",
  
  feature4Title: "更懂游戏的本地化服务",
  feature4Description: "专注于游戏本地化翻译工作，深度理解游戏文案、对话、界面等多场景内容的需求。拥有丰富的游戏术语库，确保游戏体验具有更本地化的表达，让玩家更好地理解您的游戏。",
  
  // Feature 4 Additional
  professionalGlossary: "专业术语表",
  professionalTerminologyDatabase: '专业术语数据库',
  cheese: 'Cheese',
  feeding: 'Feeding',
  rush: 'Rush',
  balance: 'Balance',
  fightingGamesJapanese: '格斗游戏 - 日语',
  mobaGamesKorean: 'MOBA游戏 - 韩语',
  starcraftRussian: '星际争霸 - 俄语',
  actionGamesChinese: '动作游戏 - 中文',
  more: "更多",
  
  // Features Section Additional
  translationTimeComparison: "翻译时间对比",
  basedOnProject: "基于20万字项目",
  traditionalAgency: "传统翻译机构",
  aiPlatform: "Flidge AI",
  days: "天",
  day: "天",
  hours: "小时",
  hour: "小时",
  "10days": "10天",
  "1day": "1天",
  "240hours": "240小时", 
  "24hours": "24小时",

  // Case Studies Section
  casesSubtitle: "服务案例",
  casesTitle: "让独立游戏被全球玩家更好地发现",
  casesDescription: "我们珍惜每一次合作机会，帮助更多独立游戏被全球更多玩家看到是我们的使命",
  
  // Game Types
  platformActionGame: "平台动作游戏",
  musicRhythmGame: "音乐节奏游戏",
  actionStealthGame: "动作潜行游戏",
  casualPuzzleGame: "休闲益智游戏",
  roguelikeCardGame: "模拟经营游戏",
  simulationGame: "模拟经营游戏",
  
  // Game Descriptions
  haakDescription: "为银河恶魔城游戏HAAK提供了14种语言支持，月销售额增长147%",
  museDashDescription: "为音乐游戏Muse Dash提供日语、韩语、英语翻译支持，为全球数亿玩家提供高质量本地化内容",
  kristalaDescription: "为动作潜行游戏Kristala提供中文翻译支持，并参与游戏名称和游戏商店页面翻译工作",
  lazyMeowDescription: "为休闲益智游戏懒猫小城提供英语、日语、韩语本地化支持，帮助游戏打入亚太市场",
  stoneSquadDescription: "为Cooking Go提供包括英语、日语、韩语、法语、西班牙语在内的12种语言支持",
  catHotelDescription: "为CatHotel提供英语、日语、简体中文、繁体中文的故事、任务、物品、商店页面翻译服务，确保更本地化的游戏体验",
  
  // Results
  monthlyRevenueGrowth: "月收入增长147%",
  playerReviews: "玩家好评",
  translationCompleted: "翻译完成",
  salesIncrease: "销量提升",
  exposureGrowth: "曝光增长",
  playerReviews2: "玩家好评",
  result: "结果",
  customerReviews: '客户评价',
  realUserFeedback: '真实用户反馈',
  
  // Pricing Section
  pricingSubtitle: "服务定价",
  pricingTitle: "透明的价格方案",
  pricingDescription: "我们提供灵活的价格方案，满足不同规模项目的需求。每个合作实体都可以享受免费试用额度。",
  
  freeTrialTitle: "免费试用额度",
  standardPricing: "标准定价",
  standardPricingDescription: "免费额度后的标准费率",
  standardPricingFeatures: {
    languages: "支持64种语言翻译",
    speed: "24小时内完成20万字符翻译",
    formats: "多种文件格式支持",
    glossary: "专业游戏术语数据库",
    quality: "质量保证和修订服务"
  },
  customPrice: "定制",
  customPlan: "价格方案",
  customPlanDescription: "大型项目专享优惠定价",
  
  // Enterprise Features
  enterpriseCustom: "企业定制",
  recommended: "推荐",
  perCharacter: "每字符",
  perLanguage: "每语言",
  startUsing: "开始使用",
  contactBusinessTeam: "联系商务团队",
  
  enterpriseFeatures: {
    allStandard: "包含所有标准功能",
    manager: "专属客户经理服务",
    priority: "优先处理和加急服务",
    customGlossary: "定制术语表和风格指南",
    discount: "批量折扣和长期合作优惠",
    extraTrial: "额外免费试用额度申请"
  },

  // Pricing Section Additional
  charactersCount: "字符数量",
  languagesCount: "语言",
  freeExperience: "免费体验", 
  freeTrialDescription: "每个合作实体可获得5000字符免费试用额度，仅限翻译为一种语言，让您充分体验我们的翻译质量",
  
  // New Pricing Calculator Section
  priceCalculator: "价格计算器",
  calculatorDescription: "快速估算您的项目翻译成本",
  targetLanguagesCount: "目标语言数量",
  estimatedCost: "预估费用",
  
  calculationNotes: "计算说明",
  calculationDetails: {
    freeQuota: "每个合作实体享受5000字符免费额度（限一种语言）",
    pricing: "超出免费额度按$0.011/字符/语言收费",
    bulkDiscount: "大批量项目可享受企业定制定价",
    finalPrice: "最终价格以商务团队报价为准"
  },

  // About Section
  aboutSubtitle: "关于我们",
  aboutTitle: "专业的游戏本地化服务团队",
  aboutDescription: "Flidge成立于2019年，是一家专注于游戏本地化的科技公司。我们将AI技术与专业人工校对相结合，为全球游戏开发者提供高质量、高效率的多语言本地化服务，帮助优秀游戏走向世界。",
  
  ourMission: "我们的使命",
  ourVision: "我们的愿景",
  missionText: "通过先进的AI技术和专业的本地化服务，打破语言壁垒，让每一款优秀的游戏都能在全球市场获得成功，让世界各地的玩家都能享受精彩的游戏体验。",
  visionText: "成为全球领先的游戏本地化服务平台，通过技术创新和专业服务为游戏行业的全球化发展贡献力量，将优秀的游戏文化传播到世界各地。",
  
  // FAQ Section
  faqSubtitle: '常见问题',
  faqTitle: '常见问题',
  faqDescription: '如果您有更多问题，请随时联系我们',
  stillHaveQuestions: "还有其他问题？",
  
  faqQuestion1: '能否提供一些试用翻译额度？',
  faqQuestion2: '建议在游戏开发的什么阶段开始使用Flidge的服务？',
  faqQuestion3: '如果我的游戏项目没有术语表怎么办？',
  faqQuestion4: '我的游戏内容会被严格保密吗？',
  
  // FAQ Items
  faq1Question: "能否提供一些试用翻译额度？",
  faq1Answer: "我们为每个合作实体提供5000字符的免费试用额度，仅限翻译为一种语言。超过5000字符后，按每字符每语言$0.016收费。如果您需要额外的免费试用额度，可以联系我们的商务团队申请。",
  
  faq2Question: "建议在游戏开发的什么阶段开始使用Flidge的服务？",
  faq2Answer: "我们建议在游戏项目开发的中后期阶段使用Flidge的服务，这样能够帮助您尽可能节省本地化成本。我们也可以提供商店页面翻译支持，帮助您选择更合适的本地化游戏名称，更容易被玩家记住，帮助您更好地开拓全球市场。如果您的游戏即将在Steam等游戏平台发布，Flidge的服务将非常适合您。我们能够在很短的时间内完成大量不同语言的本地化工作，让全球玩家都能发现您的游戏。",
  
  faq3Question: "如果我的游戏项目没有术语表怎么办？",
  faq3Answer: "我们可以通过Flidge AI为你提供术语表整理服务，帮助你更好地管理你的项目和需要翻译的内容，并与你确认核对术语的使用方式，保证这些内容在你的游戏中被正确地使用。如您需要术语表整理服务，欢迎随时与我们取得联系。",
  
  faq4Question: "我的游戏内容会被严格保密吗？",
  faq4Answer: "我们对游戏项目使用行业标准加密和专门的隔离工作流程。每个团队成员都在严格的保密协议下工作，并承担明确的财务责任。我们的开发环境确保完全的资产隔离——不允许截图、不允许外部驱动器、不允许个人设备。我们理解泄露的游戏画面、故事元素或发布日期可能会损害游戏的市场影响——您的创意知识产权将获得与我们自己未发布作品相同的保护。",
  
  // CTA Section
  ctaTitle1: "让世界",
  ctaTitle2: "爱上你的游戏",
  
  // Contact Section
  contactSubtitle: "联系我们",
  contactTitle: "获取专业翻译服务和免费试用",
  contactDescription: "填写下方表单，我们的专业团队将在24小时内为您提供详细的服务方案",
  
  name: "姓名",
  email: "邮箱",
  company: "公司/工作室名称",
  targetLanguages: "目标语言",
  projectDetails: "项目详情",
  getQuote: "获取报价",
  onlineConsult: "在线咨询",
  emailContact: "邮件联系",
  
  // Footer
  footerDescription: "专注为独立游戏提供高效、便捷、经济实惠的本地化服务，通过智能翻译、分析和个性化语言服务帮助游戏项目实现全球增长。",
  services: "服务",
  companySection: "公司",
  resources: "资源",
  featuresLink: "功能特色",
  pricingConsult: "价格咨询",
  aboutUs: "关于我们",
  helpCenter: "帮助中心",
  techBlog: "技术博客",
  termsOfService: "服务条款",
  privacyPolicy: "隐私政策",
  cookiePolicy: "Cookie政策",
  poweredBy: "由 Readdy 提供支持",
  copyright: "© 2026 Shenzhen Giant Core Limited. All rights reserved.",
  
  // Form labels
  required: "*",
  characterCount: "字符",
  
  // Form placeholders
  namePlaceholder: "请输入您的姓名",
  emailPlaceholder: "请输入您的邮箱地址",
  companyPlaceholder: "请输入公司或工作室名称",
  languagesPlaceholder: "例如：英语、日语、韩语等",
  messagePlaceholder: "请详细描述您的项目需求，包括游戏类型、翻译内容、特殊要求等...",
  
  // Alt texts
  gameIcon: "游戏图标",
  flidgeLogo: "Flidge标志",
  abstractShape: "抽象形状",
  
  // Testimonials
  testimonialSarahRole: "独立游戏开发者",
  testimonialSarahContent: "使用Flidge后，我们的游戏在海外市场获得了极佳的反馈。翻译质量远超预期，玩家都说故事传达得很完美，完全不像机器翻译。",
  
  testimonialThijsRole: "游戏工作室总监",
  testimonialThijsContent: "从最初的脚本翻译到后期的文案优化，Flidge团队展现了极高的专业水准。他们对游戏文化的理解让本地化工作变得更加顺畅。",
  
  testimonialEmmaRole: "游戏本地化经理",
  testimonialEmmaContent: "Flidge的翻译服务为我们节省了大量时间和成本。他们的AI技术不仅速度快，还能准确理解游戏中的专业术语和文化内涵。",
  
  testimonialDavidRole: "游戏制作人",
  testimonialDavidContent: "我们的游戏在日韩市场取得了巨大成功，这要归功于Flidge提供的高质量本地化服务。他们对东亚文化的深度理解让翻译更加地道。",
  
  testimonialAlexRole: "独立开发者",
  testimonialAlexContent: "作为小团队，我们最担心的就是本地化成本。Flidge不仅价格合理，效率也极高，让我们能够同时进入多个海外市场。",
  
  testimonialYukiRole: "游戏策划",
  testimonialYukiContent: "Flidge对日本游戏文化的理解让我印象深刻。他们不只是翻译文字，更是传达了游戏的精神内核，让海外玩家也能体验到原汁原味的感觉。",
  
  abstractShape2: "抽象形状2",

  // New entries from modification
  partners: "合作伙伴",
  trustedPartners: "信赖的合作伙伴",
  partnersDescription: "与全球知名游戏公司建立深度合作关系，提供专业可靠的本地化服务",

  gameProjectsServed: "服务游戏项目",
  supportedLanguages: "支持语言",
  clientSatisfaction: "客户满意度",
  responseTime: "响应时间",

  // Additional Metrics
  translatedCharactersCount: "500万+",
  avgTranslationSpeedValue: "10倍",
  translatedCharacters: "翻译字符数",
  avgTranslationSpeed: "平均翻译速度",
  clientSatisfactionRate: "客户满意率",
  servicedCompanies: "服务公司数",
  successMetrics: "成功指标",
  serviceImpact: "服务影响",

  // Statistics
  stat1Number: '80+',
  stat1Label: '服务游戏项目',
  stat2Number: '64',
  stat2Label: '支持语言',
  stat3Number: '97%',
  stat3Label: '客户满意度',
  stat4Number: '24小时',
  stat4Label: '响应时间',

  // Terms of Service
  termsTitle: '服务条款',
  termsLastUpdated: '最后更新：2025年1月',
  terms1Title: '1. 条款接受',
  terms1Content: '通过访问和使用Flidge AI翻译服务，您接受并同意受本协议条款和条件的约束。',
  terms2Title: '2. 使用许可',
  terms2Content: '我们授予您临时下载Flidge网站上材料副本的权限，仅供个人、非商业性临时查看使用。',
  terms3Title: '3. 免责声明',
  terms3Content: 'Flidge网站上的材料按"现状"提供。Flidge不作任何明示或暗示的保证，并在此否认和否定所有其他保证，包括但不限于适销性、特定用途适用性或不侵犯知识产权的暗示保证或条件。',
  terms4Title: '4. 责任限制',
  terms4Content: '在任何情况下，Flidge或其供应商均不对因使用或无法使用Flidge网站上的材料而产生的任何损害（包括但不限于数据丢失或利润损失或业务中断造成的损害）承担责任。',
  terms5Title: '5. 材料准确性',
  terms5Content: 'Flidge网站上出现的材料可能包含技术、排版或摄影错误。Flidge不保证其网站上的任何材料准确、完整或最新。',
  terms6Title: '6. 链接',
  terms6Content: 'Flidge未审查链接到我们网站的所有站点，对任何此类链接站点的内容不承担责任。',
  terms7Title: '7. 修改',
  terms7Content: 'Flidge可能随时修改其网站的服务条款，恕不另行通知。使用本网站即表示您同意受当时现行版本的服务条款约束。',
  terms8Title: '8. 适用法律',
  terms8Content: '这些条款和条件受法律管辖并按其解释，您不可撤销地服从法院的专属管辖权。',

  // Privacy Policy
  privacyTitle: '隐私政策',
  privacyLastUpdated: '最后更新：2025年1月',
  privacy1Title: '1. 我们收集的信息',
  privacy1Content: '我们收集您直接提供给我们的信息，例如当您创建账户、使用我们的翻译服务或联系我们寻求支持时。这可能包括您的姓名、电子邮件地址、公司信息以及您提交翻译的内容。',
  privacy2Title: '2. 我们如何使用您的信息',
  privacy2Content: '我们使用收集的信息来提供、维护和改进我们的翻译服务，处理交易，发送技术通知和支持消息，回应您的评论和问题，以及监控使用模式。',
  privacy3Title: '3. 信息共享',
  privacy3Content: '除本政策所述情况外，我们不会在未经您同意的情况下出售、交易或以其他方式将您的个人信息转让给第三方。我们可能与协助我们运营服务的可信服务提供商共享信息。',
  privacy4Title: '4. 数据安全',
  privacy4Content: '我们实施适当的安全措施来保护您的个人信息免受未经授权的访问、更改、披露或销毁。但是，通过互联网传输的方法都不是100%安全的。',
  privacy5Title: '5. 数据保留',
  privacy5Content: '我们保留您的个人信息的时间为提供我们的服务和实现本政策中概述的目的所必需的时间，除非法律要求更长的保留期。',
  privacy6Title: '6. 您的权利',
  privacy6Content: '您有权访问和更新您的个人信息，请求删除您的个人数据，反对处理，请求数据可移植性，以及在适用的情况下撤回同意。',
  privacy7Title: '7. Cookie和跟踪',
  privacy7Content: '我们使用Cookie和类似的跟踪技术来增强您在我们网站上的体验。您可以通过浏览器首选项控制Cookie设置。有关更多详细信息，请参阅我们的Cookie政策。',
  privacy8Title: '8. 国际传输',
  privacy8Content: '您的信息可能会被传输到您所在国家以外的国家并在那里处理。我们确保根据适用的数据保护法律采取适当的保障措施来保护您的个人信息。',
  privacy9Title: '9. 本政策的变更',
  privacy9Content: '我们可能会不时更新本隐私政策。我们将通过在此页面上发布新政策并更新"最后更新"日期来通知您任何重大变更。',
  privacy10Title: '10. 联系我们',
  privacy10Content: '如果您对本隐私政策有任何疑问，请通过privacy@flidge.ai或我们的联系表单与我们联系。',

  // Cookie Policy
  cookieTitle: 'Cookie政策',
  cookieLastUpdated: '最后更新：2025年1月',
  cookie1Title: '1. 什么是Cookie',
  cookie1Content: 'Cookie是当您访问我们的网站时放置在您设备上的小文本文件。它们通过记住您的偏好和了解您如何使用我们的服务来帮助我们为您提供更好的体验。',
  cookie2Title: '2. 我们使用的Cookie类型',
  cookie2Content: '我们使用必要的Cookie来实现基本网站功能，性能Cookie来分析使用模式，以及功能Cookie来记住您的偏好并提供增强功能。',
  cookie2Essential: '必要Cookie',
  cookie2EssentialDesc: '这些Cookie对于网站正常运行是必需的。它们启用基本功能，如页面导航和访问网站的安全区域。',
  cookie2Performance: '性能Cookie',
  cookie2PerformanceDesc: '这些Cookie收集有关访问者如何使用我们网站的信息，例如最常访问哪些页面。这些数据帮助我们改善网站性能。',
  cookie2Functional: '功能Cookie',
  cookie2FunctionalDesc: '这些Cookie允许网站记住您做出的选择并提供增强的、更个性化的功能。',
  cookie3Title: '3. 第三方Cookie',
  cookie3Content: '我们可能使用在您的设备上放置Cookie的第三方服务。这些包括分析服务、社交媒体平台和广告网络。每个第三方都有自己的隐私和Cookie政策。',
  cookie4Title: '4. 管理Cookie',
  cookie4Content: '您可以通过浏览器设置控制和管理Cookie，删除现有Cookie，设置发送Cookie时的通知，或使用隐私浏览模式。',
  cookie5Title: '5. Cookie同意',
  cookie5Content: '通过继续使用我们的网站，您同意我们按照本政策中描述的方式使用Cookie。您可以随时通过调整浏览器设置或联系我们来撤回您的同意。',
  cookie6Title: '6. 禁用Cookie的影响',
  cookie6Content: '如果您选择禁用Cookie，我们网站的某些功能可能无法正常工作。这可能会影响您的用户体验并限制对某些服务的访问。',
  cookie7Title: '7. 本政策的更新',
  cookie7Content: '我们可能会不时更新本Cookie政策，以反映我们实践中的变化或出于其他运营、法律或监管原因。请定期查看此页面以获取更新。',
  cookie8Title: '8. 联系信息',
  cookie8Content: '如果您对我们使用Cookie有任何疑问，请通过cookies@flidge.ai或我们的联系表单与我们联系。'
};

export default common;
